import { render } from "./breadScrum.vue?vue&type=template&id=28465521&scoped=true"
import script from "./breadScrum.vue?vue&type=script&lang=js"
export * from "./breadScrum.vue?vue&type=script&lang=js"

import "./breadScrum.vue?vue&type=style&index=0&id=28465521&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hkun\\Downloads\\print_shop-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28465521"]])

export default __exports__